import type { FC } from "react";

import { Box, TextField, Typography } from "@mui/material";
import CustomSwitch from "../../../CustomSwitch";

import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

interface RulesTabZboziCaseProps {
  minReviews?: number;
  selectedVariant?: string;
  minReviewStars?: number;
  withRepeat: boolean;
  onToggleWithRepeat: () => void;
  onChangeMinReviews?: (value: number) => void;
  onChangeMinReviewStars?: (value: number) => void;
}

export const RulesTabZboziCase: FC<RulesTabZboziCaseProps> = ({
  minReviews,
  selectedVariant,
  minReviewStars,
  withRepeat,
  onToggleWithRepeat,
  onChangeMinReviews,
  onChangeMinReviewStars,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        boxSizing: "border-box",
        padding: "16px 0",
      }}
    >
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          height: 104,
        }}
      >
        <TextField
          sx={{ width: 1 }}
          type='number'
          variant='outlined'
          label={t(
            "campaign.notifications.settings.displayRules.zbozi.maxReviews",
          )}
          value={minReviews ?? 1}
          onChange={e =>
            onChangeMinReviews &&
            onChangeMinReviews(parseInt(e.target.value, 10))
          }
          InputProps={{
            style: { height: 44 },
          }}
        />
        <Box
          sx={{
            display: "flex",
            width: 1,
            justifyContent: "space-between",
          }}
        >
          {selectedVariant === "zboziProductRating" && (
            <Box
              sx={{
                display: "flex",
                width: 1,
                justifyContent: "space-between",
              }}
            >
              <Typography
                style={{
                  flex: 1,
                  color: theme.palette.natural.t1,
                  fontSize: 16,
                }}
              >
                {t(
                  "campaign.notifications.settings.displayRules.heureka.reviewsWithRating",
                )}
              </Typography>
              <TextField
                style={{ width: 108, marginRight: 12 }}
                type='number'
                variant='outlined'
                value={minReviewStars}
                onChange={e =>
                  onChangeMinReviewStars &&
                  onChangeMinReviewStars(Number(e.target.value))
                }
                InputProps={{
                  inputProps: { min: 0 },
                  style: { height: 44 },
                }}
              />
              <Typography
                style={{
                  color: theme.palette.natural.t1,
                  fontSize: 16,
                  width: 72,
                }}
              >
                {t(
                  "campaign.notifications.settings.displayRules.heureka.stars",
                )}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
      <Box style={{ flex: 1 }}>
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            height: 40,
          }}
        >
          <Typography style={{ color: theme.palette.natural.t1, fontSize: 16 }}>
            {t(
              "campaign.notifications.settings.displayRules.repeatNotification",
            )}
          </Typography>
          <CustomSwitch checked={withRepeat} onSwitch={onToggleWithRepeat} />
        </Box>
      </Box>
    </Box>
  );
};
